<template>
	<div>
		<h3>{{ $t('invoice.iban_control.titre') }}</h3>

		<b-alert show variant="warning">
			<p class="mb-2"><strong>{{ $t('invoice.iban_control.' + check.status) }}</strong></p>
			<p class="mb-0">{{ $t('invoice.iban_control.avertissement') }}</p>
		</b-alert>

		<div class="form-group">
			<label>{{ $t('invoice.iban_control.iban_facture') }}</label>
			<e-copybox boxed :value="check.iban" readonly></e-copybox>
			<small v-if="check.bic" class="text-muted">{{ $t('invoice.iban_control.bic') }} : {{ check.bic }}</small>
		</div>

		<!-- Les comptes déjà connus sont montrés en regard : c'est en les comparant que l'on voit si
		     celui de la facture ressemble à un compte existant à quelques caractères près. -->
		<div v-if="check.known_ribs.length > 0" class="form-group">
			<label>{{ $t('invoice.iban_control.ibans_connus') }}</label>
			<ul class="list-unstyled mb-0">
				<li v-for="rib in check.known_ribs" :key="`known-rib-${rib.tiersrib_id}`">
					{{ rib.tiersrib_content }}
					<span class="text-muted">({{ $t('tiers.rib_status.' + rib.tiersrib_status) }})</span>
				</li>
			</ul>
		</div>

		<div class="text-center mt-4">
			<button class="btn btn-secondary btn-rounded mr-2" :disabled="processing" @click.prevent="decide('quarantaine')">
				{{ $t('invoice.iban_control.mettre_en_quarantaine') }}
				<font-awesome-icon :icon="['fal', 'shield-alt']"/>
			</button>
			<button class="btn btn-primary btn-rounded" :disabled="processing" @click.prevent="decide('approuve')">
				{{ $t('invoice.iban_control.approuver') }}
				<font-awesome-icon v-if="processing" :icon="['fas', 'spinner']" pulse/>
				<font-awesome-icon v-else :icon="['fal', 'check']"/>
			</button>
		</div>
	</div>
</template>

<script type="text/javascript">
	import Invoice from "@/mixins/Invoice.js"

	export default {
		name: 'IbanControl',

		mixins: [Invoice],

		props: {
			invoicesupplier_id: { type: Number, required: true },
			check: { type: Object, required: true }
		},

		data() {
			return {
				processing: false
			}
		},

		methods: {
			/**
			 * Enregistre la décision de l'utilisateur sur l'IBAN de la facture.
			 *
			 * La quarantaine est retenue elle aussi, et pas seulement l'approbation : sans elle, le
			 * même compte serait présenté comme une découverte à chaque facture, et l'avertissement
			 * finirait par être cliqué sans être lu.
			 *
			 * @param {String} status 'approuve' ou 'quarantaine'.
			 */
			async decide(status) {
				if(this.processing) {
					return
				}

				this.processing = true
				const res = await this.saveInvoiceSupplierIban(this.invoicesupplier_id, status)
				this.processing = false

				if(!res) {
					this.failureToast('toast.info_save_failed')
					return
				}

				this.$emit('decided', res)
			}
		}
	}
</script>
